/*Bearer ${token}`
 * Canonical human-readable labels for job service IDs.
 * Keep in sync with accounting-api/src/services/feeScheduleService.js → SERVICE_LABELS
 */
export const SERVICE_LABELS = {
  vat:                 "VAT Returns",
  payroll:             "Payroll (PAYE)",
  accounts:            "Accounts Prep",
  corporation_tax:     "CT600",
  self_assessment:     "Self Assessment (SA)",
  company_secretarial: "Confirmation Statement (CS01)",
  mtd_quarterly:       "MTD Quarterly",
  ad01_address_change: "Address Change (AD01)",
  year_end:            "Year End",
};

/*Bearer ${token}` Friendly labels for auto-generated task types (used in grouped views). */
export const TASK_TYPE_LABELS = {
  YEAR_END:               "Year End",
  ACCOUNTS_PREPARATION:   "Accounts Preparation",
  CT600:                  "CT600",
  CONFIRMATION_STATEMENT: "Confirmation Statement",
  VAT_RETURN:             "VAT Return",
  PAYROLL:                "Payroll",
};

/*Bearer ${token}` Returns a friendly label for a serviceId, falling back to the raw id. */
export function getServiceLabel(serviceId) {
  if (!serviceId) return "—";
  return SERVICE_LABELS[serviceId] || serviceId.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}


